import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Observable } from "rxjs";
import { QcDashboardDataService } from "../qc-dashboard-data.service";
import { environment } from "src/environments/environment";
import { ConsensusTemplateDataResponse } from "../qc-dashboard.model";
import { Dictionary } from "src/app/store/models/common_types";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";
@Component({
  selector: "app-consensus-template",
  templateUrl: "./consensus-template.component.html",
  styleUrls: ["./consensus-template.component.scss"],
  host: { class: "consensus-template-component" },
})
export class ConsensusTemplateComponent implements OnInit, OnChanges {
  @Input() ticker: string;
  @Output() changeNotes: EventEmitter<any> = new EventEmitter();
  consensusTableData: any;
  dataObservable: Observable<any | any>;
  errorMsg = "Something went wrong!";
  notesData: Dictionary<any> = {};
  hasError = false;
  assets = environment.assetUrl;
  constructor(
    private dataService: QcDashboardDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([exclamationTriangle]);
  }

  ngOnInit() {
    this.notesData = { ...this.notesData, isLoading: true };
    this.dataObservable = this.dataService.getConsensusTemplateData(
      this.ticker,
    );
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.ticker.previousValue !== this.ticker) {
      this.notesData = { ...this.notesData, isLoading: true };
      this.changeNotes.emit(this.notesData);
      this.dataObservable = this.dataService.getConsensusTemplateData(
        this.ticker,
      );
    }
  }
  onFailure(response) {
    if (response.status === "error") {
      this.hasError = true;
      this.errorMsg = "Sorry, something went wrong.";
    }
  }
  onGridDataResolved(response: ConsensusTemplateDataResponse) {
    if (response.status === "error") {
      this.hasError = true;
      this.errorMsg = "Sorry, something went wrong.";
    }
    const totalData = response.data_total.map((val) => {
      val.selected = true;
      return val;
    });
    const data = response.data.map((val) => {
      val.selected = false;
      return val;
    });
    this.notesData = { ...response.note_response, isLoading: false };
    this.consensusTableData = [...totalData, ...data];
    this.changeNotes.emit(this.notesData);
  }
  onRowSelection(row) {
    this.consensusTableData = this.consensusTableData.map((val) => {
      val.selected = false;
      return val;
    });
    row.selected = true;
    if (row.tabsn === "All") {
      this.changeNotes.emit(this.notesData);
      return;
    }
    const note =
      (this.notesData.data &&
        this.notesData.data.filter((val) => {
          return val.tabsn === row.tabsn;
        })) ||
      [];
    if (note.length === 0) {
      note.push({
        tabfullname: row.name,
        tabsn: row.tabsn,
        value: [],
      });
    }
    this.changeNotes.emit({ ...this.notesData, data: note });
  }
}
